export enum Method {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE'
}

export default class ServiceWrapper {

	private static token?: string;
	private apiUrl: string =  '/seguimiento/api';

	private buildUrl(path: string): string {
		return `${this.apiUrl}\\${path}`;
	}

	public static setToken(token: string) {
		ServiceWrapper.token = token;
	}

	public request(path: string = '', method: Method = Method.GET, body?: string |FormData | ArrayBuffer, content: string = 'application/json') {
		var headers = new Headers();
		headers.set('Content-Type', content);
		if (ServiceWrapper.token) {
			headers.set('Authorization', `Bearer ${ServiceWrapper.token}`);
		}
		const url = this.buildUrl(path);
		const req = new Request(url, {
			mode: 'cors',
			headers,
			method,
			body
		});
		return fetch(req);
	}

	public get(path: string) {
		return this.request(path, Method.GET);
	}

	public post(path: string, body: string |FormData | ArrayBuffer) {
		return this.request(path, Method.POST, body);
	}

	public put(path: string, body: string |FormData | ArrayBuffer) {
		return this.request(path, Method.PUT, body);
	}

	public delete(path: string) {
		return this.request(path, Method.DELETE);
	}
}
